import React from "react";
import styles	from "./ModalForm.styl"


const Modal = ({ toggleModal, sendToEmail, onChange}) => (
	<div className={styles.modalBackground}>
		{ /* Modal box */ }
		<div className={styles.modalBox}>
			{ /* Heading */ }
			<div className={styles.heading}>
				<h1 className={styles.title}>Личные данные</h1>
				<div
					className={styles.symbol}
					onClick={() =>toggleModal()}>
					&#10006;
				</div>
			</div>
			{ /* Content */ }
			<div className={styles.content} >
				<div className={styles.contentItem}>
					<span>ФИО</span>
					<input className={styles.input} type={"text"}  placeholder={'ФИО'} required onChange={(e)=>onChange(e.target.value,'FIO')}/>
				</div>
				<div className={styles.contentItem}>
					<span>Номер телефона</span>
					<input className={styles.input} type={'tel'} placeholder={'+7(***)***-**-**'} required onChange={(e)=>onChange(e.target.value,'phone')}/>
				</div>
				<div className={styles.contentItem}>
					<span>Email</span>
					<input className={styles.input} type={'email'} placeholder={'Введите адрес электронной почты'} required onChange={(e)=>onChange(e.target.value,'email')}/>
				</div>
				<button style={{marginLeft:'200px'}} onClick={()=>sendToEmail()}>Отправить</button>
			</div>
		</div>
	</div>
)
export default Modal;



// WEBPACK FOOTER //
// ./src/react/ui/features/ModalForm.jsx